import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";

export const fetchConfig = createAsyncThunk(
    'config/fetchConfig',
    async () => {
        return axios({
            method: 'get',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-settings`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);
        })
    }
);
export const saveConfig = createAsyncThunk(
    'config/saveConfig',
    async (payload) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/global-settings`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
);

export const activateSupportPlugin = createAsyncThunk(
    'config/activateSupportPlugin',
    async (params) => {

        return axios({
            method: 'put',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/config/extensions`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `application/json`,
                "Access-Control-Allow-Origin": '*',
            },
            data: params
        })
            .then(response => {
                return response.data.data;

            })
            .catch(function (error) {

                throw new Error(error.response.data.message);

            });
    }
);

export const saveIosAppStoreConfig = createAsyncThunk(
    'config/saveIosAppStoreConfig',
    async (payload) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/key-integration`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)

export const saveBasicInfo = createAsyncThunk(
    'config/saveBasicInfo',
    async (payload) => {
        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/store-basic-info`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            response.data['basic_info_tour_guide_modal'] = true;
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)
export const saveNotificationConfig = createAsyncThunk(
    'config/saveNotificationConfig',
    async (payload) => {

        return axios({
            method: 'post',
            url: `${appLocalizer.apiUrl}/appza/web/api/v1/notification-config`,
            headers: {
                "Accept": `application/json`,
                "Content-Type": `multipart/form-data`,
                "Access-Control-Allow-Origin": '*',
            },
            data: payload
        }).then((response) => {
            return response.data;
        }).catch((error) => {
            throw new Error(error.response.data.message);

        })
    }
)